import { PureComponent } from "react";
import { componentStyles } from "./testimonials-text-and-asset-component.scss";
import FullTestimonialsQuote from "segments/desktop/core-components/full-testimonials-quote/full-testimonials-quote";
import SideBySideTextAndAsset from "segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset";
import { MD } from "constants/sizes";
import { AUTO } from "constants/cloudinary-asset-qualities";
import YoutubeVideoWithPosterComponent from "components/core/youtube-video-with-poster/youtube-video-with-poster-component";

export default class TestimonialsTextAndAssetComponent extends PureComponent {
  getProps = () => {
    const { youtubeWithPosterProps, ...rest } = this.props;

    if (youtubeWithPosterProps?.videoId) {
      return {
        replaceAssetComponent: YoutubeVideoWithPosterComponent,
        replaceAssetComponentProps: youtubeWithPosterProps,
        ...rest
      };
    }

    return this.props;
  };

  render() {
    return (
      <div className="testimonials-text-and-asset-component">
        <SideBySideTextAndAsset replaceTextComponent={FullTestimonialsQuote} {...this.getProps()} />
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

TestimonialsTextAndAssetComponent.defaultProps = {
  paddingTop: "64px",
  paddingBottom: "64px",
  titleSize: MD,
  asset: {
    position: "center",
    fitToContainer: true,
    image: {
      src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/text-and-asset/board-with-dragged-column-in-circle.png"
    }
  },
  assetQuality: AUTO,
  fullParagraph: { ...FullTestimonialsQuote.defaultProps }
};
